var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base_div",attrs:{"id":"app"}},[_c('Header',{attrs:{"headertxt":"Welcome to Genamet"}}),_c('router-view'),_c('Footer',{attrs:{"footertxt":"Genamet.com All rights reserved"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }